// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marginTop--yiNCy {
  margin-top: 2rem;
}
.chatWrapper--mJA4T {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  grid-column: 1 / 4;
  grid-row: 1;
  overflow-y: auto;
  padding: 1rem;
}
.chatWrapper--mJA4T > div {
  max-width: 48rem;
  margin: 0 auto;
  width: 100%;
}
.chatWrapper--mJA4T > div::-webkit-scrollbar {
  background: #FFF;
  width: 14px;
}
.chatWrapper--mJA4T > div::-webkit-scrollbar-thumb {
  background: #6B83A8;
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  border-radius: 9999px;
}
@media (max-width: 42rem) {
  .chatWrapper--mJA4T > div {
    padding: 0 1rem;
  }
}
.chatWrapper--mJA4T h3 {
  margin: 3rem 0 0 0;
}
.chatWrapper--mJA4T .chatItem--LBokH {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
}
.chatWrapper--mJA4T .chatItem--LBokH.skeleton--NyE32 .answer--MH82t {
  min-height: 71px;
  border-radius: 4px;
  animation: skeleton--NyE32 ease-in 2s infinite;
  background: linear-gradient(90deg, #F7F7F7 25%, #ecf1ff 50%, #F7F7F7 75%);
  background-size: 300% 300%;
}
.chatWrapper--mJA4T .chatItem--LBokH .question--Humgp,
.chatWrapper--mJA4T .chatItem--LBokH .answer--MH82t {
  padding: 0.5rem 1.5rem;
  margin-top: 0.5rem;
  color: #1A202C;
}
.chatWrapper--mJA4T .question--Humgp {
  background-color: #F9FBFF;
  border-radius: 4px;
}
.chatWrapper--mJA4T .answer--MH82t {
  background-color: #ecf1ff;
  border-radius: 4px;
}
.chatWrapper--mJA4T .boclips-player-container {
  margin-bottom: 1rem;
}
@keyframes skeleton--NyE32 {
  0% {
    background-position: 0 100%;
  }
  50% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/chatArea/style.module.less"],"names":[],"mappings":"AAaA;EACE,gBAAA;AAZF;AAeA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAbF;AAKA;EAWI,gBAAA;EACA,cAAA;EACA,WAAA;AAbJ;AAeI;EACE,gBAAA;EACA,WAAA;AAbN;AAgBI;EACE,mBAAA;EACA,kCAAA;EACA,4BAAA;EACA,qBAAA;AAdN;AAiBI;EAAA;IACE,eAAA;EAdJ;AACF;AAfA;EAiCI,kBAAA;AAfJ;AAlBA;EAqCI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAhBJ;AAkBI;EAEI,gBAAA;EACA,kBAAA;EACA,8CAAA;EACA,yEAAA;EAMA,0BAAA;AAtBR;AA/BA;;EA2DM,sBAAA;EACA,kBAAA;EACA,cAAA;AAxBN;AArCA;EAkEI,yBAAA;EACA,kBAAA;AA1BJ;AAzCA;EAuEI,yBAAA;EACA,kBAAA;AA3BJ;AA7CA;EA4EI,mBAAA;AA5BJ;AAgCA;EACE;IACE,2BAAA;EA9BF;EAgCA;IACE,2BAAA;EA9BF;EAgCA;IACE,2BAAA;EA9BF;AACF","sourcesContent":["@import \"~@boclips-ui/styles/src/colors\";\n\n@border-color: #caced1;\n@border: 1px solid @border-color;\n@radius: 4px;\n@question-color: @blue-100;\n@answer-color: rgb(236, 241, 255);\n@error-color: rgb(226, 147, 0);\n@box-shadow: var(\n  --bo-ui-video-card-box-sahdow,\n  0px 4px 12px rgba(0, 0, 0, 0.1)\n);\n\n.marginTop {\n  margin-top: 2rem;\n}\n\n.chatWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  grid-column: 1 / 4;\n  grid-row: 1;\n  overflow-y: auto;\n  padding: 1rem;\n\n  > div {\n    max-width: 48rem;\n    margin: 0 auto;\n    width: 100%;\n\n    &::-webkit-scrollbar {\n      background: @white;\n      width: 14px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: @gray-500;\n      border: 4px solid rgba(0, 0, 0, 0);\n      background-clip: padding-box;\n      border-radius: 9999px;\n    }\n\n    @media (max-width: 42rem) {\n      padding: 0 1rem;\n    }\n  }\n\n  h3 {\n    margin: 3rem 0 0 0;\n  }\n\n  .chatItem {\n    margin-top: 1rem;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 2rem;\n\n    &.skeleton {\n      .answer {\n        min-height: 71px;\n        border-radius: 4px;\n        animation: skeleton ease-in 2s infinite;\n        background: linear-gradient(\n          90deg,\n          @gray-100 25%,\n          @answer-color 50%,\n          @gray-100 75%\n        );\n        background-size: 300% 300%;\n      }\n    }\n\n    .question,\n    .answer {\n      padding: 0.5rem 1.5rem;\n      margin-top: 0.5rem;\n      color: @gray-900;\n    }\n  }\n\n  .question {\n    background-color: @question-color;\n    border-radius: @radius;\n  }\n\n  .answer {\n    background-color: @answer-color;\n    border-radius: @radius;\n  }\n\n  :global(.boclips-player-container) {\n    margin-bottom: 1rem;\n  }\n}\n\n@keyframes skeleton {\n  0% {\n    background-position: 0 100%;\n  }\n  50% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: 0 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"marginTop": `marginTop--yiNCy`,
	"chatWrapper": `chatWrapper--mJA4T`,
	"chatItem": `chatItem--LBokH`,
	"skeleton": `skeleton--NyE32`,
	"answer": `answer--MH82t`,
	"question": `question--Humgp`
};
export default ___CSS_LOADER_EXPORT___;
